import { MouseEventHandler, MutableRefObject, TouchEventHandler, useEffect } from 'react';

export default function useOnClickOutside(
  ref: MutableRefObject<any>,
  handler: MouseEventHandler | TouchEventHandler
): void {
  useEffect(() => {
    const listener = (event: any): void => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}
